export default {
  async setIsComparing({ commit }, payload) {
    commit("SET_IS_COMPARING", payload);
  },

  async setSelectedDate({ commit }, params) {
    commit("SET_SELECTED_DATE", params);
  },
  async setSelectedFacility({ commit }, payload) {
    commit("SET_SELECTED_FACILITY", payload);
  },

  async clearSelectedFacility({ commit }) {
    commit("SET_SELECTED_FACILITY", {});
  },

  async clearComparison({ commit }) {
    commit("SET_COMPARISON_DATE", null);
    commit("SET_IS_COMPARING", false);
  },

  async setComparisonDate({ commit }, payload) {
    commit("SET_COMPARISON_DATE", payload);
  },
  setCurrentSelectedCategory({ commit }, payload) {
    commit("SET_SELECTED_CATEGORY", payload);
  },
  setDataGrid({ commit }, payload) {
    commit("SET_DATA_GRID", payload);
  },
  setIsAutoCategorized({ commit }, payload) {
    commit("SET_IS_AUTO_CATEGORIZED", !!payload);
  }
};
